import React from 'react';

/** @type import('@contentful/rich-text-react-renderer').NodeRenderer */
export default function Paragraph(node, children) {
  if (
    node.content.length === 1 &&
    node.content[0]?.nodeType === 'text' &&
    node.content[0]?.value === ''
  ) {
    return null;
  }
  return <p>{children}</p>;
}
